import * as React from 'react'
import './Tooltip.scss'

export interface ITooltipProps {
  /**
   * Tooltip toggle boolean.
   */
  isTooltipVisible: boolean
  /**
   * Content of tooltip.
   */
  children: React.ReactNode
}

export class Tooltip extends React.PureComponent<ITooltipProps> {
  tooltipBEM = () => {
    const { isTooltipVisible } = this.props
    const classArray = ['tooltip']

    if (isTooltipVisible) {
      classArray.push('tooltip--visible')
    }

    return classArray.join(' ')
  }

  render() {
    return (
      <span className={this.tooltipBEM()}>
        <div className="tooltip__content">{this.props.children}</div>
      </span>
    )
  }
}
